/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@atlaskit/css';
import type { LogoProps } from '@atlaskit/logo/types';

const sizeMap: Record<NonNullable<LogoProps['size']>, string> = {
	xxsmall: '16px',
	xsmall: '20px',
	small: '24px',
	medium: '32px',
	large: '40px',
	xlarge: '48px',
};

const iconStyles = css({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const TwgLogoIcon = ({
	size = 'small',
	label = 'Atlassian Teamwork Graph',
	testId = 'twg-logo-icon',
}: LogoProps): JSX.Element => {
	const resolvedSize = sizeMap[size ?? 'small'];

	return (
		<span
			css={iconStyles}
			data-testid={testId}
			aria-label={label || undefined}
			role={label ? 'img' : undefined}
			aria-hidden={label === '' ? true : undefined}
		>
			<svg
				width={resolvedSize}
				height={resolvedSize}
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path stroke="#a9abaf" strokeWidth="1.5" d="M11 11 5 5" />
				<circle cx="3.5" cy="3.5" r="1.75" stroke="#a9abaf" strokeWidth="1.5" />
				<circle cx="3.5" cy="12.5" r="1.75" stroke="#a9abaf" strokeWidth="1.5" />
				<circle cx="12.5" cy="12.5" r="1.75" stroke="#a9abaf" strokeWidth="1.5" />
				<circle cx="12.5" cy="3.5" r="1.75" stroke="#a9abaf" strokeWidth="1.5" />
			</svg>
		</span>
	);
};
